import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import AldooRouter from "aldoo-ra/Router"
import AldooPageRenderer from "aldoo-ra/AldooComponent/renderers/AldooPageRenderer.jsx"

function Page() {
  const pageContext = usePageContext()
  const urlPathname = pageContext.urlPathname
  // a page made in Admin → Structure, found by the server render (+onBeforeRender): the browser's router
  // knows only the code's routes, and one of them may take the same address (/vendor/* takes /vendor/offer)
  if (pageContext.dynamicPage) return <AldooPageRenderer pageData={pageContext.dynamicPage} pageContext={pageContext} />
  const Component = AldooRouter.resolve(urlPathname)
  
  if (!Component) {
    // If no component found, resolve the /404 route instead
    const NotFoundComponent = AldooRouter.resolve("/404")
    if (NotFoundComponent) {
      return <NotFoundComponent pageContext={pageContext} />
    }
    // Fallback if even /404 route doesn't exist
    return <div>404 - Page not found</div>
  }
  
  return <Component pageContext={pageContext} />
}

export default Page